/** Locale-aware formatting helpers. Formatters are built once, not per call. */

const brl = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const decimal = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const integer = new Intl.NumberFormat('pt-BR');

/**
 * `29.9` → `"R$ 29,90"`.
 *
 * Use apenas para valores de configuração (frete grátis, taxa de entrega), que
 * são escritos em reais. Valores de produto e de carrinho passam por
 * `formatCents` — dinheiro só circula em centavos inteiros.
 */
export function formatCurrency(value: number): string {
  return brl.format(value);
}

/** `1.5` → `"1,5"` */
export function formatNumber(value: number): string {
  return decimal.format(value);
}

/** `1200` → `"1.200"` */
export function formatInteger(value: number): string {
  return integer.format(value);
}

/** `10.1` → `"10,1 kg"`; sub-kilo weights render in grams. */
export function formatWeight(weightKg: number): string {
  if (weightKg < 1) return `${formatNumber(weightKg * 1000)} g`;
  return `${formatNumber(weightKg)} kg`;
}

/** `0.18` → `"18%"` — used for the discount pill. */
export function formatPercent(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}

/**
 * Formats a raw digit string as a Brazilian mobile number while the user types.
 * `11989326704` → `(11) 98932-6704`
 */
export function formatPhoneBR(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
